<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
        @reset="$gjReset"
        @query="$gjNoticeQuery">
        <gj-country-server-select
          v-model="filter.countryMarketValue"
        ></gj-country-server-select>
        <gj-select
          v-model="filter.templateType"
          placeholder="模板类型"
          :options="templateTypeOptions"
          width="132px"
          key="templateType"
        ></gj-select>
        <gj-select
          v-model="filter.createUser"
          placeholder="创建用户"
          :options="activeUserOptions"
          width="132px"
          key="createUser"
        ></gj-select>
        <gj-select
          v-model="filter.updateUser"
          placeholder="更新用户"
          :options="activeUserOptions"
          width="132px"
          key="updateUser"
        ></gj-select>
        <gj-select-date-picker
          v-model="filter.date"
          :options="[
            {id: 'create', text: '创建时间'},
            {id: 'update', text: '更新时间'},
          ]"
          type="daterange"
        ></gj-select-date-picker>
        <gj-search-input
          v-model="filter.templateName"
          placeholder="请输入模板名称"
          width="150px"
        ></gj-search-input>
        <template #right>
          <view-setting
            :ref="REF_VIEW_SETTING"
            save-mode="remote"
            :use-default="true"
            :module-name="moduleName"
            :config="model"
            :fn-generate-params="generateViewParams"
            @view-change="handleChangeView"
            @view-complete="handCompleteView">
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #tool-group>
      <gj-tool-group
        :download="$permission('listing:export')"
        download-url="/crm/mailTemplate/export"
        :download-params="globalParams"
        :sort-gjtable="$refs.gjTable"
        help
        setting
        :table-name="tableName"
        :table-columns="columns">
      </gj-tool-group>
    </template>
    <template #operate-group>
      <gj-button type="primary" @click="addTemplate(null)">新增模板</gj-button>
      <gj-button :disabled="noSelect" @click="batchDeleteTemplate(selectedRows)">批量删除</gj-button>
    </template>
    <template #table>
      <gj-table
        ref="gjTable"
        :name="tableName"
        adaptParent
        :columns="columns"
        :data="tableData"
        selection
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery"
        :pagination="pagination"
        :loading="loading"
        :default-sort="defaultSort">
        <template v-slot:name="{ row }">
          <gj-popover trigger="click" placement="left">
              <template slot="reference">
                <gj-tooltip :text-line="1" :content="row.name">
                  <span class="colorBlue gj-pointer">{{row.name}}</span>
                </gj-tooltip>
              </template>
            <div class="popoverContent" v-html="row.content">
            </div>
          </gj-popover>
        </template>
        <template v-slot:countryCodeString="{ row }">
          <gj-tooltip :text-line="1" :content="isMeaningful(row.countryCodeString) ? row.countryCodeString : '所有国家'">
            {{isMeaningful(row.countryCodeString) ? row.countryCodeString : '所有国家'}}
          </gj-tooltip>
        </template>
        <template v-slot:markets="{ row }">
          <gj-tooltip :text-line="1" :content="isMeaningful(row.markets) ? row.markets : '所有店铺'">
            {{isMeaningful(row.markets) ? row.markets : '所有店铺'}}
          </gj-tooltip>
        </template>
        <template v-slot:op="{ row }">
          <gj-button-group type="dropdown-op">
            <gj-button type="text" @click="editTemplate(row)">编辑</gj-button>
            <gj-button type="text" @click="deleteTemplate(row.id)">删除</gj-button>
              <template #dropdown>
                <gj-dropdown-item
                  @click="viewTemplate(row)">
                  查看
                </gj-dropdown-item>
                <gj-dropdown-item
                  @click="addTemplate(row)">
                  复制
                </gj-dropdown-item>
                <gj-dropdown-item
                    @click="openLog(row.id)">
                  日志
                </gj-dropdown-item>
              </template>
            </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {isMeaningfulMixin, queryMixin, selectionMixin} from "../../../../minxins";
  import MailTemplateEdit from './modal/mail-template-edit';
  import {batchDeleteTemplate, deleteTemplate, getMailTemplatePage, getTemplateType} from "../../../../api/crm";
  import {defaultVal, isMeaningful} from "../../../../utils/common";
  import {convertToDate, generateViewParams} from "../../../../utils/date.util";
  import {mapGetters} from "vuex";
  import model from './viewConfig'

  export default {
    name: "mail-template",
    mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
    data() {
      return {
        moduleName: 'MAIL_TEMPLATE',
        model,
        tableName: 'mailTemplate',
        tableData: [],
        columns: [
          {id: 'name', header: '模板名称', field: 'slot:name', minWidth: '180px', disabled: true, default: true, fixed: 'left', sortable: true},
          {id: 'templateTypeName', header: '模板类型', field: 'templateTypeName', disabled: true, default: true, minWidth: '100px', fixed: 'left'},
          {id: 'countryCodeString', header: '适用国家', field: 'slot:countryCodeString', disabled: true, default: true, minWidth: '140px', fixed: 'left'},
          {id: 'markets', header: '适用店铺', field: 'slot:markets', minWidth: '200px', disabled: true, default: true, fixed: 'left'},
          {id: 'createName', header: '创建用户', field: 'userName', default: true, minWidth: '140px'},
          {id: 'updateName', header: '最近更新用户', field: 'updateUserName', default: true, minWidth: '140px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', default: true, minWidth: '140px', sortable: true},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', default: true, minWidth: '140px', sortable: true},
          {id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right', notCustomColumn: true},
        ],
        defaultSort: {
          order: 'descending',
          prop: "updateTime"
        },
        filter: {
          // marketIds: [],
          countryMarketValue: null,
          templateName: null,
          createUser: null,
          updateUser: null,
          date: {
            key: 'update',
            value: null,
          },
        },
        templateTypeOptions: [],
        notStorage: true,
      }
    },
    computed: {
      ...mapGetters({
        activeUserOptions: 'activeUserOptions'
      })
    },
    created() {
      this.requestTemplateType()
    },
    methods: {
      requestTemplateType() {
        getTemplateType()
          .then((res) => {
            this.templateTypeOptions = res.data

          })
          .complete(() => (this.loading = false));
      },
      $gjQuery() {
        this.loading = true;
        const params = {
          model: {
            // marketIds: this.filter.marketIds,
            name: this.filter.templateName,
            templateType: this.filter.templateType,
            userId: defaultVal(this.filter.createUser, null),
            updateUser: defaultVal(this.filter.updateUser, null),
          },
          ...this.queryPagination,
          ...this.querySort,
        };
        if (this.filter.countryMarketValue) {
          params.model.countryCodes = this.filter.countryMarketValue.countryIds;
          params.model.marketIds = this.filter.countryMarketValue.marketIds;
        }
        if (isMeaningful(this.filter.date) && isMeaningful(this.filter.date.value)) {
          params.model[this.filter.date.key + 'StartTime'] = convertToDate(this.filter.date.value[0]);
          params.model[this.filter.date.key + 'EndTime'] = convertToDate(this.filter.date.value[1]);
        }
        this.globalParams = params;
        getMailTemplatePage(params)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            countryMarketValue: null,
            // marketIds: [],
            templateName: null,
            templateType: null,
            createUser: null,
            updateUser: null,
            date: {
              key: 'update',
              value: null,
            },
          }
        }
      },
      generateViewParams,
      addTemplate(row) {
        this.openTemplateModal(row, 'add');
      },
      editTemplate(row) {
        this.openTemplateModal(row, 'edit');
      },
      viewTemplate(row) {
        this.openTemplateModal(row, 'view');
      },
      deleteTemplate(id) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '删除确认',
            content: '删除模板后不可恢复，确认删除？',
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteTemplate(id)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                }).complete(() => modal.confirmLoading = false)
            }
          }
        });
      },
      batchDeleteTemplate(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '删除确认',
            content: '删除模板后不可恢复，确认删除？',
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              batchDeleteTemplate({ids: rows.map(v => v.id)})
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                }).complete(() => modal.confirmLoading = false)
            }
          }
        });
      },
      openTemplateModal(item, state) {
        const modal = this.$gjCreate(MailTemplateEdit, {
          props: {
            item: item,
            state: state
          },
          on: {
            after: () => {
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        })
      },
      openLog(id) {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: `/crm/mailTemplate/${id}/logs`,
            columns: [
              {id: 'createTime', header: '操作时间', field: 'createTime', minWidth: '120px'},
              {id: 'opUser', header: '操作用户', field: 'userName', minWidth: '100px'},
              {id: 'op', header: '操作分类', field: this.opTypeOption ? 'option:op' : 'op', options: this.opTypeOption, overflowLine: 2,  minWidth: '120px'},
              {id: 'content', header: '操作内容', field: 'content', overflowLine: 2,  minWidth: '200px'}
            ]
          }
        })
      },
      clickDownload() {
        // exportListing(this.globalParams)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .popoverContent {
    width: 300px;
    height: 200px;
    overflow: auto;
  }
</style>
